export const messages = {
  en: {
    reportCustomComponentRelManage: {
      title: 'Report Custom Component Relation Management',
      relId: 'Relation ID',
      componentName: 'Component Name',
      customId: 'Report ID',
      seq: 'Sequence',
      createTime: 'Create Time',
      associateComponent: 'Associate Component',
      fetchError: 'Failed to fetch component relations'
    },
    addReportCustomComponentRel: {
      title: 'Add Component Relation',
      component: 'Component',
      seq: 'Sequence',
      chooseComponent: 'Choose Component',
      componentRequired: 'Component is required',
      seqRequired: 'Sequence is required',
      seqMustNumber: 'Sequence must be number',
      saveSuccess: 'Save successfully',
      saveError: 'Failed to save'
    },
    chooseReportCustomComponent: {
      title: 'Choose Report Component',
      searchPlaceholder: 'Input component name',
      componentId: 'Component ID',
      componentName: 'Component Name',
      componentType: 'Component Type',
      queryModel: 'Query Model',
      remark: 'Remark',
      fetchError: 'Failed to fetch components'
    },
    deleteReportCustomComponentRel: {
      title: 'Confirm Delete',
      confirmMessage: 'Are you sure to delete this component relation?',
      deleteSuccess: 'Delete successfully',
      deleteError: 'Failed to delete'
    }
  },
  zh: {
    reportCustomComponentRelManage: {
      title: '报表自定义组件关系管理',
      relId: '关系编号',
      componentName: '组件名称',
      customId: '报表编号',
      seq: '组件序号',
      createTime: '关联时间',
      associateComponent: '关联组件',
      fetchError: '获取组件关系失败'
    },
    addReportCustomComponentRel: {
      title: '添加组件关系',
      component: '组件',
      seq: '组件序号',
      chooseComponent: '选择组件',
      componentRequired: '组件不能为空',
      seqRequired: '组件序号不能为空',
      seqMustNumber: '组件序号必须为数字',
      saveSuccess: '保存成功',
      saveError: '保存失败'
    },
    chooseReportCustomComponent: {
      title: '选择报表组件',
      searchPlaceholder: '输入报表组件名称',
      componentId: '组件ID',
      componentName: '组件名称',
      componentType: '组件类型',
      queryModel: '查询方式',
      remark: '描述',
      fetchError: '获取组件列表失败'
    },
    deleteReportCustomComponentRel: {
      title: '确认删除',
      confirmMessage: '确定删除该组件关系吗？',
      deleteSuccess: '删除成功',
deleteError: '刪除失敗'
    }
  },
  'zh-TW': {
    reportCustomComponentRelManage: {
      title: '報表自訂組件關係管理',
      relId: '關係編號',
      componentName: '組件名稱',
      customId: '報表編號',
      seq: '組件序號',
      createTime: '關聯時間',
      associateComponent: '關聯組件',
      fetchError: '獲取組件關係失敗'
    },
    addReportCustomComponentRel: {
      title: '添加組件關係',
      component: '組件',
      seq: '組件序號',
      chooseComponent: '選擇組件',
      componentRequired: '組件不能為空',
      seqRequired: '組件序號不能為空',
      seqMustNumber: '組件序號必須為數字',
      saveSuccess: '保存成功',
      saveError: '保存失敗'
    },
    chooseReportCustomComponent: {
      title: '選擇報表組件',
      searchPlaceholder: '輸入報表組件名稱',
      componentId: '組件ID',
      componentName: '組件名稱',
      componentType: '組件類型',
      queryModel: '查詢方式',
      remark: '描述',
      fetchError: '獲取組件列表失敗'
    },
    deleteReportCustomComponentRel: {
      title: '確認刪除',
      confirmMessage: '確定刪除該組件關係嗎？',
      deleteSuccess: '刪除成功',
      deleteError: '刪除失敗'
    }
  }
}